<template>
    <vs-row vs-justify="center" id="queue-box">
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-xs="12"
      >
        <vs-card id="queue-create-form">

          <vs-row>
          <vs-col vs-w="6">

            <vs-input
            class="inputx w-100 mb-4"
            :label="$t('Queue.Create.NameAgent')"
            :placeholder="$t('Queue.Create.NameAgent')"
            v-model="title"
            :danger="errors.title"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Queue.Create.QueueName') })
            "
/>




          </vs-col>

          <vs-col vs-w="6">

            <vs-input
            class="inputx w-100 mb-4"
            :label="$t('Queue.Create.LastAgent')"
            :placeholder="$t('Queue.Create.LastAgent')"
            v-model="last"
            :danger="errors.last"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Queue.Create.QueueName') })
            "
          />
            </vs-col>
          </vs-row>


          <vs-row>
  <vs-col vs-w="6">
    <vs-input
      class="inputx w-100 mb-4"
      :label="$t('Queue.Create.Date')"
    :placeholder="$t('Queue.Create.Date')"
    v-model="currentDate"
    :value="getCurrentDate()"
    readonly/>
    </vs-col>

 
            



          </vs-row>

    
          <vs-row>

            <vs-col vs-w="6">
              <vs-select
            :danger="errors.choices"
            :danger-text="
              $t('Errors.Required', {
                field: $t('Queue.Create.ProblemeType'),
              })
            "
            :placeholder="$t('Queue.Create.ProblemeType')"
            class="w-100 mb-4"
            :label="$t('Queue.Create.ProblemeType')"
            autocomplete
            multiple
            v-model="choices"
          >
            <vs-select-item
              :key="'service_' + index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in servicesList"
            />
          </vs-select>
            </vs-col>

            <vs-col vs-w="6">
              <vs-select
            :danger="errors.services"
            :danger-text="
              $t('Errors.Required', {
                field: $t('Queue.Create.AvailableServices'),
              })
            "
            :placeholder="$t('Queue.Create.AvailableServices')"
            class="w-100 mb-4"
            :label="$t('Queue.Create.AvailableServices')"
            autocomplete
            multiple
            v-model="services"
          >
            <vs-select-item
              :key="'service_' + index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in servicesList"
            />
          </vs-select>
  
 
            </vs-col>

          </vs-row>
            <vs-input
            class="inputx w-100 mb-4"
            :label="$t('Queue.Create.SubjectAgentss')"
            :placeholder="$t('Queue.Create.SubjectAgentss')"
            v-model="title"
            :danger="errors.subject"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Queue.Create.QueueName') })
            "
          />
   

          <vs-textarea
          
          class="inputx w-100 mb-6"
            :label="$t('Queue.Create.AgentsDetails')"
            :placeholder="$t('Queue.Create.AgentsDetails')"
            v-model="details"
            :danger="errors.details"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Queue.Create.QueueName') })
            "
          />

  
    
          <vs-row >
        <vs-col vs-w="2">
          <vs-button
            color="primary"
            class="w-100 mb-2"
            @click="createSupport"
            >{{ $t("Queue.Create.Send") }}</vs-button
          >
        </vs-col>
      </vs-row>
 
  
    
        </vs-card>
        <!--V-Tour start-->
        <v-tour name="QueuesCreate" :steps="steps">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions" class="v-step__buttons">
                    <button @click="tour.nextStep" class="v-step__button">
                      Next
                    </button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 1">
                  <div slot="actions" class="v-step__buttons">
                    <button @click="tour.previousStep" class="v-step__button">
                      Previous
                    </button>
                    <button @click="goToNextPage" class="v-step__button">
                      Next
                    </button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </vs-col>
    </vs-row>
  </template>
  
  <script>
  import QueueWorkingDay from "../../components/queue/QueueWorkingDay";
  import {
    privateServiceService,
    queueService,
    teamService,
    departmentService,
  } from "../../_services";
  import router from "../../_helpers/router";
  import { mapState } from "vuex";
import VsPrism from '../../components/prism/VsPrism.vue';
  
  export default {
    name: "organization-box",
    data: () => ({
      title: "",
      subject:"",
      selected:'',
      choosable: 0,
      date:'',
      currentTime:'',
      ticket_start: 0,
      ticket_prefix: "",
      ask_covid: false,
      auto_call: false,
      synchronized: false,
      require_booking: false,
      ticket_number_type: "Rand",
      queueWorkingDays: [],
      servicesList: [],
      queuesList: [],
      queues: [{ title: "" }],
      teamMembersList: [],
      services: [],
      choices:[],
      members: [],
      errors: {
        title:false,
        name: false,
        last: false,
        email: false,
        choices: false,
        subject: false,
        details: false,
        services: false,
        members: false,
      },
      counters: [{ name: "" }, { queue_services: [] }],
  
      steps: [
        {
          target: "#queue-create-form", // We're using document.querySelector() under the hood
          header: {
            title: "New queue form",
          },
          params: {
            placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#create-submit-button",
          params: {
            placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
      ],
      departments: [],
      target_department: [],
      auto_push: false,
    }),
    methods: {
      notify(title, text, type) {
        this.$vs.notify({
          color: type,
          title: title,
          text: text,
        });
      },
      showLoading() {
        this.$vs.loading({
          container: "#queue-box",
          scale: 0.6, 
        });
      },

      createSupport(){
      this.$vs.loading({
        container: '#organization-box',
        scale: 0.6
      });
      try{
        let support = new FormData()
        support.append('title',this.title);
        support.append('subject',this.subject);
        support.append('description',this.details);

        privateServiceService.createContact(support).catch(function () {
        }.bind(this)).finally(function () {
            this.$vs.loading.close('#organization-box > .con-vs-loading');
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Organization.OrganizationAdd.ToastSuccessMessage"),"success"
            );
            this.$router.push('/organizations')
          }.bind(this));
          } catch (e) {
              this.$vs.loading.close('#organization-box > .con-vs-loading');
              this.notify(
                this.$t("Toasts.Error"),
                this.$t("Organization.OrganizationAdd.ToastFailMessage"),"danger");
            }
      },


      getCurrentDate() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  },



      validateFields() {
        this.errors.name = this.name ? false : true;
        this.errors.last = this.name ? false : true;
        this.errors.email = this.name ? false : true;
        this.errors.choices = this.choices.length > 0 ? false : true;
        this.errors.services = this.services.length > 0 ? false : true;
        this.errors.members = this.members.length > 0 ? false : true;
        this.errors.subject = this.name ? false : true;
        this.errors.details = this.name ? false : true;

        let { name,last,email,choices, services, members, subject , details} = this.errors;
        return !(name || last || email|| choices || services || members || subject || details);
      },
      reset() {
        this.name = "";
        this.last = "";
        this.email = "";
        this.subject = "";
        this.details = "";

        (this.services = []), (this.members = []) , (this.choices = []);

      },
      hideLoading() {
        this.$vs.loading.close("#queue-box > .con-vs-loading");
      },
      submitForm() {
        let res = this.validateFields();
        // console.log (this.queues);
        let queues_priority = [];
        let customer_priority = [];
  
        if (!res) {
          return false;
        }
        this.showLoading();
  
        let services = this.services.map((id) => {
          let restricted_counter_id = null;
          return { id, restricted_counter_id };
        });
  
        var queue = {
          title: this.name,
          services: JSON.stringify(services),
          members: this.members.join(),
          counters: this.counters.map(function (obj) {
            return obj.name;
          }),
          choosable: this.choosable,
          ask_covid: this.ask_covid,
          auto_call: this.auto_call,
          require_booking: this.require_booking,
          ticket_start: this.ticket_start,
          ticket_prefix: this.ticket_prefix,
          ticket_number_type: this.ticket_number_type,
          target_department: this.target_department.join(),
          working_days: JSON.stringify(this.queueWorkingDays),
          auto_push: this.auto_push,
        };
        if (this.synchronized) {
          this.queues.forEach((obj) => {
            queues_priority.push(obj.id);
            customer_priority.push(obj.number);
          });
          let queue_config = {
            queues: queues_priority,
            customers: customer_priority,
          };
          queue.queue_config = JSON.stringify(queue_config);
        }
        queueService
          .create(queue)
          .then(
            function (data) {
              this.notify(
                this.$t("Toasts.Successful"),
                this.$t("Queue.Create.ToastSuccess"),
                "success"
              );
              // router.go(-1);
            }.bind(this)
          )
          .catch(
            function () {
              this.notify(
                this.$t("Toasts.Error"),
                this.$t("Queue.Create.ToastFail"),
                "danger"
              );
            }.bind(this)
          )
          .finally(
            function () {
              this.hideLoading();
              // this.reset();
            }.bind(this)
          );
      },
      addCounter() {
        this.counters.push({ value: "" });
      },
      addQueue() {
        console.log(this.queues);
        this.queues.push({ value: "" });
      },
      deleteCounter(index) {
        this.counters.splice(index, 1);
      },
      deleteQueue(index) {
        this.queues.splice(index, 1);
      },
      goToNextPage() {
        router.push({ path: "/bookings?istour=on" });
      },
    },
    computed: {
      ...mapState({
        workingDays: (state) => state.account.user.working_days,
      }),

      currentDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const day = now.getDate()
      return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
    }
    },
    mounted() {
    
      this.queueWorkingDays = { ...this.workingDays };
      queueService.getAll().then(
        function (data) {
          console.log(data.queues.data);
          this.queuesList = data.queues.data;
        }.bind(this)
      );
      privateServiceService
        .getAll()
        .then(
          function (data) {
            this.servicesList = [];
            data.services.forEach((obj) => {
              this.servicesList.push({ id: obj.service_id, name: obj.title });
            });
          }.bind(this)
        )
        .finally(
          function () {
            if (this.servicesList.length == 0) {
              this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: this.$t("Service.NoServiceAlert.Title"),
                text: this.$t("Service.NoServiceAlert.Text"),
                acceptText: this.$t("Service.NoServiceAlert.GoToServicesButton"),
                cancelText: this.$t("Toasts.CancelButton"),
                accept: function () {
                  this.$router.push("/settings/services");
                }.bind(this),
                cancel: function () {
                  this.$router.back();
                }.bind(this),
              });
            }
            this.$route.query.istour ? this.$tours["Queues"].start() : "";
          }.bind(this)
        );
  
      teamService.getAll().then(
        function (data) {
          this.teamMembersList = data.team.data.map(function (obj) {
            return { id: obj.id, name: obj.fname + " " + obj.lname };
          });
        }.bind(this)
      );
      this.$t("Queue.Create.Content").map(
        (content, index) => (this.steps[index].content = content)
      );
      this.$route.query.istour && localStorage.getItem("skipTour") != "true"
        ? this.$tours["QueuesCreate"].start()
        : "";
  
      departmentService.getAll().then(
        function (data) {
          this.departments = data.departments;
          console.log(this.departments);
        }.bind(this)
      );
    },
    components: {
      QueueWorkingDay,
    },
  };
  </script>
 
        VsPrism 